import { logger } from './logger';

export class InputHandler {
  private onJump: () => void;
  private keydownListener: (e: KeyboardEvent) => void;
  private touchListener: (e: TouchEvent) => void;
  private clickListener: (e: MouseEvent) => void;
  private canvas: HTMLCanvasElement | null = null;

  constructor(onJump: () => void) {
    this.onJump = onJump;

    // イベントリスナーの作成
    this.keydownListener = this.handleKeydown.bind(this);
    this.touchListener = this.handleTouch.bind(this);
    this.clickListener = this.handleClick.bind(this);

    // キャンバス要素を取得
    this.canvas = document.getElementById('game-canvas') as HTMLCanvasElement;

    // イベントリスナーの登録
    this.enable();
  }

  /**
   * キーボード入力を処理
   */
  private handleKeydown(event: KeyboardEvent): void {
    // スペースキーでジャンプ
    if (event.code === 'Space' || event.key === ' ') {
      event.preventDefault(); // スクロールを防ぐ
      this.onJump();
    }
  }

  /**
   * タッチ入力を処理（キャンバスのみ）
   */
  private handleTouch(event: TouchEvent): void {
    // UI要素（ボタンなど）のタッチは無視
    const target = event.target as HTMLElement;
    if (target.tagName === 'BUTTON' || target.tagName === 'INPUT') {
      return;
    }

    // キャンバスまたはゲーム画面のタッチのみジャンプ
    const gameScreen = document.getElementById('game-screen');
    if (gameScreen && !gameScreen.classList.contains('hidden')) {
      event.preventDefault();
      this.onJump();
    }
  }

  /**
   * クリック入力を処理
   */
  private handleClick(event: MouseEvent): void {
    // ゲーム画面のクリックでジャンプ
    if (event.target === this.canvas) {
      this.onJump();
    }
  }

  /**
   * 入力を有効化
   */
  public enable(): void {
    window.addEventListener('keydown', this.keydownListener);
    window.addEventListener('touchstart', this.touchListener, { passive: false });
    window.addEventListener('click', this.clickListener);
    logger.log('Input handler enabled');
  }

  /**
   * 入力を無効化
   */
  public disable(): void {
    window.removeEventListener('keydown', this.keydownListener);
    window.removeEventListener('touchstart', this.touchListener);
    window.removeEventListener('click', this.clickListener);
    logger.log('Input handler disabled');
  }

  /**
   * クリーンアップ
   */
  public dispose(): void {
    this.disable();
  }
}
